import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { first, map } from 'rxjs';

/**
 * Guard for canMatch - route only matches if user is authenticated.
 * Use to conditionally match routes based on auth state.
 */
export const isAuthenticatedMatch: CanMatchFn = () => {
  const authService = inject(AuthService);
  return authService.isAuthenticated().pipe(first());
};

/**
 * Guard for canMatch - route only matches if user is NOT authenticated.
 */
export const isNotAuthenticatedMatch: CanMatchFn = () => {
  const authService = inject(AuthService);
  return authService.isAuthenticated().pipe(
    first(),
    map((isAuth) => !isAuth),
  );
};
